<template>
  <div
    v-loading="loading">
    <div v-show="isManagement" class="manage-content">
      <el-row :gutter="10">
        <el-col :span="4" class="left-box">
          <corner-box class="box-element">
            <div class="left-item-box">
              <span>能源类型：</span>
              <el-select v-model="energyType" class="w170">
                <el-option v-for="item in energyTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </div>
            <div class="left-item-box">
              <span>区域：</span>
              <el-tree
                :data="treeList"
                node-key="id"
                ref="tree"
                show-checkbox
                :props="defaultProps"
                :default-checked-keys="defaultCheckedTreeKey"
                :default-expand-all="true">
              </el-tree>
            </div>
          </corner-box>
        </el-col>
        <el-col :span="20" class="right-box">
          <corner-box class="box-element">
            <div class="top-item-box">
              <span>时间周期：</span>
              <el-radio-group v-model="dateType" @change="changePeriod" v-for="item in periodList" :key="item.id">
                <el-radio-button :label="item.id">{{item.name}}</el-radio-button>
              </el-radio-group>
              <span>时间范围：</span>
              <el-date-picker
                v-model="startDate"
                :type="timeType"
                :format="timeFormat"
                :value-format="timeFormat"
                :picker-options="defaultSdate"
                :key="'start'+startDate"
                :clearable='false'
              ></el-date-picker>
              —
              <el-date-picker
                v-model="endDate"
                :type="timeType"
                :format="timeFormat"
                :value-format="timeFormat"
                :picker-options="defaultEdate"
                :key="'end'+endDate"
                :clearable='false'
              ></el-date-picker>
              <el-button @click="query">查询</el-button>
              <el-button class="fr" @click="toSet()">定额设置</el-button>
            </div>
            <span class="title">单位/商户用电量(kW·h)</span>
            <el-table :data="tableData"  :span-method="objectSpanMethod">
              <el-table-column   label="区域" prop="areaName"></el-table-column>
              <el-table-column   label="建筑名称" prop="buildingName"></el-table-column>
              <el-table-column   label="单位/商户名称" prop="unitName"></el-table-column>
              <el-table-column v-for="item in columnList" :label="item.label" :key="item.label">
                <el-table-column  v-for="item1 in item.child" :label="item1.label" :prop="item1.prop" :key="item1.label"></el-table-column>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="10"
              background
              layout="total, prev, pager, next"
              :total="totalNum"></el-pagination>
          </corner-box>
        </el-col>
      </el-row>
    </div>
    <div v-show="!isManagement" class="set-content">
      <div>
        <div class="select-cell">
          <span class="item-name">能源类型：</span>
          <el-select v-model="energyType">
            <el-option v-for="item in energyTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <div class="select-cell">
          <span class="item-name">周期：</span>
          <el-select v-model="set.period" @change="changeSetPeriod">
            <el-option v-for="item in set.periodList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <div class="select-cell">
          <span class="item-name">时间范围：</span>
          <el-date-picker
            v-model="set.startDate"
            :type="set.timeType"
            :format="set.timeFormat"
            :value-format="set.timeFormat"
            :picker-options="set.defaultSdate"
            :key="'start'+set.startDate"
            :clearable='false'
          ></el-date-picker>
          —
          <el-date-picker
            v-model="set.endDate"
            :type="set.timeType"
            :format="set.timeFormat"
            :value-format="set.timeFormat"
            :picker-options="set.defaultEdate"
            :key="'end'+set.endDate"
            :clearable='false'
          ></el-date-picker>
        </div>
        <i class="iconfont iconfanhui fr" style="margin-left: 20px; cursor: pointer;" @click="isManagement = true"></i>
        <el-button class="fr" @click="dialogShow = true">批量导入</el-button>
      </div>
      <div>
        <div class="select-cell">
          <span class="item-name">区域：</span>
          <el-select v-model="set.area" @change="getBuildingList()">
            <el-option v-for="item in set.areaList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <div class="select-cell">
          <span class="item-name">建筑名称：</span>
          <el-select v-model="set.building" @change="getUnitList()">
            <el-option v-for="item in set.buildingList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <div class="select-cell">
          <span class="item-name">单位/商户：</span>
          <el-select v-model="set.unit">
            <el-option v-for="item in set.unitList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </div>
        <el-button class="select-cell" @click="sure()">确定</el-button>
      </div>
      <el-table class="set-table" :data="set.tableData" border>
        <el-table-column  width="200" label="区域" prop="areaName"></el-table-column>
        <el-table-column  width="200" label="建筑名称" prop="buildingName"></el-table-column>
        <el-table-column  width="200" label="单位/商户名称" prop="unitName"></el-table-column>
        <el-table-column v-for="(item,index) in set.colList" :label="item.label" :prop="item.prop" :key="index">
          <template slot-scope="scope">
            <el-input class="w100" v-model="scope.row[item.prop]"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="fr" @click="reset">恢复</el-button>
      <el-button class="fr" style="margin-right: 20px;" @click="submit()">提交</el-button>
    </div>
    <el-dialog title="导入数据" :visible.sync="dialogShow" width="30%">
      <div class="btn-item">
        <span class="item-name">导入数据类型：</span>
        <el-button @click="downLoad()">下载模板</el-button>
      </div>
      <div class="btn-item">
        <span class="item-name">上传数据：</span>
        <el-button @click="upLoad()">点击上传</el-button>
      </div>
      <div class="btn-item">
<!--        <el-input id="fname" :disabled="true" type="text" class="w200" tabindex="1" style="margin-right:10px" v-model="file"></el-input>-->
        <!--用于显示上传文件名的input-->
        <el-input id="addFileId" type="file" accept=".xls,.xlsx" style="display:none;"  @change="afterSelect()"  v-model="file"></el-input>
        <!--实际起作用的file型input-->
      </div>
      <div class="item-notes">仅支持Excel（Excel最大1M）</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="dialogShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CornerBox from "@/components/cornerBox";
import {getSession} from "@/assets/js/tools/instruments";
import axios from "axios";


export default {
  name: "quotaManagement",
  components: {CornerBox},
  data(){
    return {
      loading: false,
      energyType: 'elec',
      energyTypeList: [],
      treeList: [],
      defaultCheckedTreeKey: [],
      defaultProps: {
        children: 'child',
        label: 'categoryName'
      },
      periodList: [],
      tableData:[],
      columnList: [],
      dateType: 'y',
      // endDate: this.getMonth(new Date()),
      endDate: '2022',
      // startDate: this.getMonth(new Date(new Date()-1000 * 60 * 60 * 24 * 12 * 30)),
      startDate: '2022',
      timeType: 'year',
      timeFormat: 'yyyy',
      defaultSdate: {
        disabledDate:(time)=>{
          return time.getTime() >= new Date(this.endDate).getTime() ||time.getTime()<new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
        }
      },
      defaultEdate: {
        // disabledDate:(time)=>{
        //   return time.getTime() <= new Date(this.startDate).getTime() || time.getTime()>new Date().getTime()
        // }
      },
      mergecell: [],
      currentPage: 1,
      totalNum: 0,
      isManagement: true,
      set: {
        period: '',
        periodList: [],
        startDate: '',
        endDate: '',
        timeType: 'month',
        timeFormat: 'yyyy-MM',
        defaultSdate: {
          disabledDate:(time)=>{
            return time.getTime() >= new Date(this.set.endDate).getTime() ||time.getTime()<new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
          }
        },
        defaultEdate: {
          disabledDate:(time)=>{
            return time.getTime() <= new Date(this.set.startDate).getTime()
          }
        },
        building: '',
        buildingList: [],
        unit: '',
        unitList: [],
        area: '',
        areaList: [],
        tableData: [],
        colList: [
          // {
          //   label: '2022-03预设用电量（kW·h）',
          // }
        ],
      },
      file: '',
      dialogShow: false,
      firstToken: true
    }
  },
  mounted() {
    this.getTreeList();
    this.query();
  },
  methods: {
    getTreeList(){
      this.$get('quotamanagement/getbuildinglist').then((response)=>{
        this.treeList = response.tree
        this.defaultCheckedTreeKey = this.getTreeChild(this.treeList);
        this.energyTypeList = response.energyType
        this.periodList = response.period
      })
    },
    changePeriod(val){
      this.startDate = '';
      this.endDate = '';
      if(val == 'y'){
        this.timeType = 'year';
        this.timeFormat = 'yyyy'
        this.set.timeType = 'year'
        this.set.timeFormat = 'yyyy'
        this.startDate = new Date().getFullYear().toString()
        this.endDate = new Date().getFullYear().toString()
      }else if(val == 'm'){
        this.timeType = 'month'
        this.timeFormat = 'yyyy-MM'
        this.set.timeType = 'month'
        this.set.timeFormat = 'yyyy-MM'
        this.startDate = this.getMonth(new Date())
        this.endDate = this.getMonth(new Date())
      }
    },
    changeSetPeriod(val){
      this.set.startDate = '';
      this.set.endDate = '';
      if(val == 'y'){
        this.set.timeType = 'year'
        this.set.timeFormat = 'yyyy'
        this.set.startDate = new Date().getFullYear().toString()
        this.set.endDate = new Date().getFullYear().toString()
        // this.set.startDate = new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 31 * 12).getFullYear().toString()
        // this.set.endDate = new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 31 * 12).getFullYear().toString()
      }else if(val == 'm'){
        this.set.timeType = 'month'
        this.set.timeFormat = 'yyyy-MM'
        // this.set.startDate = this.getMonth(new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 30))
        // this.set.endDate = this.getMonth(new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 30))
        this.set.startDate = this.getMonth(new Date())
        this.set.endDate = this.getMonth(new Date())
      }
    },
    query(){
      this.loading = true;
      let str = ''
      if(this.$refs.tree.getCheckedKeys().length === 0){
        str = '0'
      }else{
        str = this.$refs.tree.getCheckedKeys(true).join(',')
      }
      this.$get('quotamanagement/getbuildingenergyquota',[
        this.energyType,str,this.dateType,this.startDate.replace('-',''),this.endDate.replace('-',''),this.currentPage,10
      ]).then((response)=>{
        this.columnList = response.columnList;
        this.tableData = response.tableData;
        this.mergecell = response.mergecell;
        this.totalNum = response.totalNumber;
        this.loading = false;
      })
    },
    handleCurrentChange(){
      this.query();
    },
    toSet(){
      this.isManagement = false;
      this.set.period = this.dateType;
      if(this.set.period === 'm'){
        this.set.timeType = 'month';
        this.set.timeFormat = 'yyyy-MM';
        this.set.startDate = this.getMonth(new Date())
        this.set.endDate = this.getMonth(new Date())
        // this.set.startDate = this.getMonth(new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 30))
        // this.set.endDate = this.getMonth(new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 30))
      }
      else{
        this.set.timeType = 'year';
        this.set.timeFormat = 'yyyy';
        this.set.startDate = new Date().getFullYear().toString()
        this.set.endDate = new Date().getFullYear().toString()
        // this.set.startDate = new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 31 * 12).getFullYear().toString()
        // this.set.endDate = new Date(new Date(this.endDate).getTime()+ 1000 * 60 * 60 * 24 * 31 * 12).getFullYear().toString()
      }
      this.getAreaList();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
        // 判断有无需要合并的单元格，mergecell 是后端返回的
        if (this.mergecell.length !== 0) {
          // 在此过滤掉不符合条件的单元格格式
          let crow = this.mergecell.filter(val => {
            return rowIndex >= val.Row && rowIndex < val.Row + val.RowSpan && columnIndex >= val.Col && columnIndex < val.Col + val.ColSpan
            // 此处意思是 判断当前的合并单元格信息，有无包含当前单元格
          })
          if (crow && crow.length !== 0) { // 判断是否有符合信息
            if (crow[0].Row === rowIndex && crow[0].Col === columnIndex) { // 由于 crow获取的是当前单元格信息包含的单元格，所以要判断一下是否是当前单元格
              // 如果是，则返回单元格格式
              return {
                rowspan: crow[0].RowSpan,
                colspan: crow[0].ColSpan
              }
            } else {
              // 如果不是，则隐藏当前格子
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        }

    },
    //获取当前月格式
    getMonth(date){
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      var M = month <10? '0'+ month:month;
      return year+'-'+M
    },
    getTreeChild(data){
      let result = [];
      let rr = function (arr){
        arr.forEach(function (item){
          result.push(item.id);
        })
      }
      rr(data)
      return result
    },
    getAreaList(){
      this.$get('quotamanagement/getscreendata',[0, 0, 0]).then((response)=>{
        this.set.areaList = response.area;
        this.set.area = response.area[0].id
        this.set.periodList = response.period;
        this.getBuildingList()
      })
    },
    getBuildingList(){
      this.$get('quotamanagement/getscreendata',[this.set.area, 0, 0]).then((response)=>{
        this.set.buildingList = response.building;
        if(response.building.length > 0){
          this.set.building = response.building[0].id
          this.getUnitList()
        }else{
          this.set.building = ''
        }
      })
    },
    getUnitList(){
      this.$get('quotamanagement/getscreendata',[this.set.area, this.set.building, 0]).then((response)=>{
        this.set.unitList = [{id: '0',name: '全部'}].concat(response.unit);
        if(response.unit.length > 0){
          this.set.unit = this.set.unitList[0].id
          if(this.firstToken){
            this.sure();
          }
          this.firstToken = false;
        }else{
          this.set.unit = '';
        }
      })
    },
    sure(){
      this.loading = true;
      this.$get('quotamanagement/getbuildingenergyquotatable',[
        this.energyType,
        this.set.area+':'+this.set.building+':'+this.set.unit,
        this.set.period,
        this.set.startDate.replace('-',''),
        this.set.endDate.replace('-',''),
      ]).then((response)=>{
        this.set.tableData = response.tableData;
        this.set.colList = response.columnList;
        this.loading = false;

      })
    },
    reset(){
      this.sure()
    },
    submit(){
      let arr = [];
      for(let i in this.set.tableData){
        let k,k1 ,k2,k3 = '';
        for(let j in this.set.tableData[i]){
          k1 = this.set.tableData[i].unitId
          if(j.substr(0,4) == 'pre_'){
            k2 = j.substr(4);
            k3 = this.set.tableData[i][j]
            k = k1+':'+k3+':'+k2
            arr.push(k)
          }
        }
      }
      this.$post('quotamanagement/postbuildingenergyquota', {
        energyType: this.energyType,
        period: this.set.period,
        energyQuotaString: arr.join(',')
      }).then(()=>{
        this.$message.success('提交成功')
      })
    },
    downLoad(){
      let array = [
        this.energyType,
        this.set.area+':'+this.set.building+':'+this.set.unit,
        this.set.period,
        this.set.startDate,
        this.set.endDate,];
      let a = document.createElement('a');
      a.setAttribute('href',this.rootUrl+'quotamanagement/downloadbuildingenergyquotatable/'+ array.join('/'));
      a.setAttribute('download','');
      a.click();
      a.remove();
    },
    upLoad(){
      document.getElementById("addFileId").click();
    },
    afterSelect(){
      var f = document.getElementById('addFileId').files[0];
      var form = new FormData();
      form.append( 'file', f);
      let config = {
        method: 'POST',
        url: this.rootUrl + 'quotamanagement/uploadbuildingenergyquotatable',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: form,
      };
      axios(config).then(() => {
        this.$message.success('上传成功')
        this.file = ''
      }, (err) => {
        this.$message.error('上传失败')
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .manage-content{
    color: $light;
    padding: 15px 10px;
    .left-box{
      .box-element{
        height: 80vh;
        padding-left: 15px;
        .left-item-box{
          margin-top: 20px;
          margin-left: 5px;
        }
      }
    }
    .right-box{
      .top-item-box{
        height: 4vh;
        margin-bottom: 30px;
        .el-button{
          margin-left: 10px;
        }
      }
      .box-element{
        height: 80vh;
        padding: 20px;
        .title{
          font-size: 16px;
        }
        .el-table{
          height: 500px;
          overflow: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .set-content{
    color: $light;
    padding: 20px;
    .select-cell{
      display: inline-block;
      color: $light;
      margin-right: 20px;
      margin-bottom: 20px;
      .item-name{
        display: inline-block;
        width: 3.5vw;
        text-align: right;
      }
    }
    .set-table{
      height: 550px;
      overflow: auto;
      margin-bottom: 20px;

    }
  }
  .btn-item{
    color: $light;
    margin-bottom: 20px;
    .item-name{
      display: inline-block;
      width: 110px;
      text-align:right;
      margin-right: 10px;
    }
  }
  .item-notes{
    color: $light;
    margin-left: 120px;
  }
  @media screen and (width:3440px) and (height: 1440px )   {

    .manage-content{
      .right-box{
        .box-element{
          .el-table{
            height: auto;
          }
        }
      }
    }
    }
</style>